/**
 * Utility function to handle API errors consistently
 * @param result - The result object from a Redux action
 * @param fallbackMessage - The fallback error message to use if no specific error is available
 * @returns The formatted error message
 */
export const getErrorMessage = (result: { error?: { message?: string } }, fallbackMessage: string): string => {
    return result.error?.message || fallbackMessage;
};

/**
 * Utility function to handle API errors and throw a standardized error
 * @param result - The result object from a Redux action
 * @param fallbackMessage - The fallback error message to use if no specific error is available
 * @throws Error with the formatted error message
 */
export const handleApiError = (result: { error?: { message?: string } }, fallbackMessage: string): never => {
    const errorMessage = getErrorMessage(result, fallbackMessage);
    throw new Error(errorMessage);
};

/**
 * Utility function to handle general errors and throw with a fallback message
 * @param error - The caught error
 * @param fallbackMessage - The fallback error message to use
 * @throws Error with the formatted error message
 */
export const handleGenericError = (error: unknown, fallbackMessage: string): never => {
    const errorMessage = error instanceof Error ? error.message : fallbackMessage;
    throw new Error(errorMessage);
};
